import { render, staticRenderFns } from "./FilesSidebar.vue?vue&type=template&id=f91af60e&scoped=true"
import script from "./FilesSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesSidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesSidebar.vue?vue&type=style&index=0&id=f91af60e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91af60e",
  null
  
)

export default component.exports